import React from "react";

interface CircularProgressProps {
  size?: number;
  color?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 32,
  color = "gray-500",
}) => {
  const borderClass = `border-4 border-t-transparent border-${color}`;
  const style = {
    width: size,
    height: size,
  };

  return (
    <div
      className={`animate-spin rounded-full ${borderClass}`}
      style={style}
    />
  );
};

export default CircularProgress;